export default "__VITE_ASSET__Bo1U6ob8__"